import { useMutation, useQueryClient } from "@tanstack/react-query";
import { cargarCfdiApi } from "@/features/cargar-cfdi/services/cargar-cfdi.api";
import { qk } from "@/lib/query-keys";
import { toastError, toastExito } from "@/lib/toast";
import type { CargarCFDIResultado } from "@/lib/types";
import { extractApiMessage } from "@/shared/api/extract-message";

/**
 * Mutation de upload · hidrata la solicitud devuelta y delega al
 * caller la decisión de qué hacer según `reglasAutorizadas`:
 *   · true  → arrancar el flow de validación SAT (polling).
 *   · false → pintar `<ReglasRechazadasCard>`.
 */
export function useCargarCfdi(
  solicitudId: string,
  options?: {
    onReglasAutorizadas?: (r: CargarCFDIResultado) => void;
    onReglasRechazadas?: (r: CargarCFDIResultado) => void;
  }
) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (xml: File) => cargarCfdiApi.cargar(solicitudId, xml),
    onSuccess: (r) => {
      qc.setQueryData(qk.solicitud(solicitudId), r.solicitud);
      if (r.reglasAutorizadas) {
        toastExito({ title: "CFDI aceptado", message: "Validando con SAT…" });
        options?.onReglasAutorizadas?.(r);
      } else {
        toastError({ title: "CFDI rechazado", message: `${r.erroresReglas.length} regla(s) rechazaron el CFDI` });
        options?.onReglasRechazadas?.(r);
      }
    },
    onError: (e) => toastError({ title: "Error", message: extractApiMessage(e, "Error subiendo CFDI") }),
  });
}
